/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AuditEventSearchOrderBy {
    EventDateTime = 'EventDateTime',
    Activity = 'Activity',
    Source = 'Source',
    InitiatedByUpn = 'InitiatedByUpn',
    TargetUpn = 'TargetUpn'
}


export function instanceOfAuditEventSearchOrderBy(value: any): boolean {
    for (const key in AuditEventSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(AuditEventSearchOrderBy, key)) {
            if (AuditEventSearchOrderBy[key as keyof typeof AuditEventSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuditEventSearchOrderByFromJSON(json: any): AuditEventSearchOrderBy {
    return AuditEventSearchOrderByFromJSONTyped(json, false);
}

export function AuditEventSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventSearchOrderBy {
    return json as AuditEventSearchOrderBy;
}

export function AuditEventSearchOrderByToJSON(value?: AuditEventSearchOrderBy | null): any {
    return value as any;
}

export function AuditEventSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): AuditEventSearchOrderBy {
    return value as AuditEventSearchOrderBy;
}

